import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { MenuItem } from 'material-ui/Menu';
import {
    getUsername,
    getPreferredUsername,
    setCurrentEnterprise,
    setUserInfo,
    currentUserInfo,
    setDomainValue,
    userCurrentEnterprise,  isManagementUser, isRecipient, isSupportUser, setReportingFlag, isGapPacketAdmin, isIBManagementUser, setCurrentEnterpriseRole,
    getCurrentActiveRole,
    getReportEnabledForSponsor,
    getReportEnabledForCRO,
    setReportEnabledForSponsor,
    setReportEnabledForCRO
} from 'spark-state/common/user/userReducer';
import { logOut, getMappedEnterpriseData } from 'spark-state/common/app/reducer';
import HeaderBar from 'spark-ui/HeaderBar/HeaderBar';
import HeaderButton from 'spark-ui/HeaderBar/HeaderButton';
import Menu from 'spark-ui/Menu/Menu';
import Permission from 'spark-util/Permission';
import MenuButton from 'spark-ui/Menu/MenuButton';
import AdminMenu from './AdminMenu';
import { trialNetworksTabLinkURL } from 'spark-api/safetyLetter/commonSafetyLetterService';
import SelectField from 'spark-ui/form/Select/Select';
import { reduxForm, reset } from 'redux-form';
import { compose } from 'recompose';
import Typography from 'material-ui/Typography';
import styles from 'spark-ui/HeaderBar/HeaderBar.css';
import { refreshRecipient, refreshManagement } from 'spark-grid';
import { useHistory } from 'react-router-dom';
import withStyles from 'material-ui/styles/withStyles';
import { popupContentStyles } from 'spark-views/enterprise/styles/AddUserPopupStyle';
import { change } from 'redux-form';
import Roles from 'spark-types/Roles';
import { getEnterpriseCtmsRefreshDate } from 'spark-api/enterpriseService';
import { setCtmsRefreshDate } from 'spark-state/enterprise/enterpriseReducer';
import { setSafetyNotifications } from 'spark-state/safetyLetter/safetyLetterReducer';
import Link from 'spark-ui/ui-kitchen/ingredients/spices/Link';
import { paths } from 'spark-views/safetyLetter/admin/adminRoutes';
import { paths as notificationPaths } from 'spark-views/safetyLetter/notifications/notificationRoutes';
import { paths as gapPacketPaths } from 'spark-views/gapPacketManagement/gapPacketRoutes';
import { paths as ibAdminPaths } from 'spark-views/InvestigatorBrochure/ibAdmin/ibAdminRoutes'; //SAF-17154 Added import for IBRoute
import { paths as ibRecipientPaths } from 'spark-views/InvestigatorBrochure/ibNotifications/ibNotificationsRoutes'
import { resourceNotFound } from 'spark-state/common/app/reducer';
import { trackUser} from 'spark-api/utilityService';
import { ArrowDropDown, Settings, Description } from '@material-ui/icons';
import { SupportLink } from 'spark-ui/Footer/Footer';
import { USER_GUIDES_BASE_PATH } from 'spark-views/userGuides/UserGuidesRoute';

export const FORM_NAME = 'EnterpriseListForm';

const SelectContainer = styled.div`
    
    display: grid;
    align-items: center; 
    svg {
        color: #fff !important;
    }
    height: 55px;
`;
const Profile = styled(MenuButton)`
    padding: 12.5px 18px;
`
const ProfileDropdown= styled.div`
    padding-right: 16px;
    padding-left: 16px;
`
const ProfileInfo= styled.div`
    padding-bottom: 8px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 16px;
`
const NameCard= styled.div`
    color: #000000;
    font-size: 16px;
    &&& {
        font-weight: 500;
    }
`
const EmailCard= styled.div`
    color: #595959;
    font-size: 14px;
    font-weight: 400;
`
const LogoutButton = styled.button`
    height: 40px;
    width: 246px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    color: #0768fd;
    font-size: 16px;
    background-color: #fff;
    cursor: pointer;
    padding: 0px 0px;
    &:hover{
        background-color: #EFF5FF;
        border: 1px solid #0768FD;
    }
`
const IconContainer = styled.span`
    display:inline-block;
    vertical-align: middle;
    &:hover{
        cursor: pointer;
    }
    & svg {
        font-size: 20px;
    }
`;
const TriggerButton = (isOpen, toggle) =>(
    <Profile onClick={toggle}>
        <UserMenuButton open={isOpen} />
        <IconContainer><ArrowDropDown/></IconContainer>
    </Profile>
        
    
);

const UserMenu = () => {
    return <Menu id={"logout"} renderTarget={TriggerButton}>{toggle => <LogoutMenuItem toggle={toggle} />}</Menu>;
};
const DescriptionStyled = styled(Description)`
    color: #595959 !important;
    font-size: 16px !important;
`;
const SettingsWithStyles = styled(Settings)`
    color: #595959 !important;
    font-size: 16px !important;
`;
const MenuLinkWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    & a {
        color: #595959 !important;
        text-decoration: none !important;
        font-size: 14px;
    }
`;
const UserGuideLink = styled(Link)`
    color: #595959 !important;
    text-decoration: none !important;
    font-size: 14px;
    &:hover {
        color: #0768fd !important;
    }
`;
let LogoutMenuItem = ({ logOut, name , email, toggle }) => (
    <ProfileDropdown>
        <ProfileInfo>
            <NameCard>{name}</NameCard>
            <EmailCard>{email}</EmailCard>
        </ProfileInfo>
        <MenuLinkWrapper>
            <DescriptionStyled /> <UserGuideLink to={USER_GUIDES_BASE_PATH} onClick={toggle} target="_blank" rel="noopener noreferrer">User Guides</UserGuideLink>
        </MenuLinkWrapper>
        <MenuLinkWrapper>
            <SettingsWithStyles /> <SupportLink />
        </MenuLinkWrapper>
        <LogoutButton onClick={logOut}>Log Out</LogoutButton>
    </ProfileDropdown>
    
);
LogoutMenuItem = connect(
    (state)=>{
        const userName = getUsername(state) || getPreferredUsername(state);
        const email = currentUserInfo(state).email;
        return ({
            name: userName,
            email: email 
        });
    }, { logOut }
)(LogoutMenuItem);

// SAF-20237: Role Assignment - Switch Roles and its Precedence - PSR-4763
// Switch Role menu for users with multiple roles in the same enterprise
const SwitchRoleTriggerButton = (isOpen, toggle) => (
    <MenuButton label="Switch Role" open={isOpen} onClick={toggle}>
        &nbsp;
        <ArrowDropDown />
    </MenuButton>
);

let SwitchRoleMenu = ({ availableRoles, onRoleChange, currentActiveRole }) => {
    return (
        <Menu id="switchRole" renderTarget={SwitchRoleTriggerButton}>
            {toggle => (
                <div>
                    {availableRoles && availableRoles.map(role => (
                        <MenuItem 
                            key={role.roleVal} 
                            selected={role.roleVal === currentActiveRole}
                            onClick={() => {
                                onRoleChange(role.roleVal);
                                toggle();
                            }}
                        >
                            {role.roleDisplayVal}
                        </MenuItem>
                    ))}
                </div>
            )}
        </Menu>
    );
};

// SAF-20237: Connect SwitchRoleMenu to get available roles for current enterprise
SwitchRoleMenu = connect(
    (state, ownProps) => {
        const enterpriseId = userCurrentEnterprise(state);
        const mappedEnterprise = getMappedEnterpriseData(state);
        const selectedEnterprise = mappedEnterprise && mappedEnterprise.find(
            (ent) => ent.entId === parseInt(enterpriseId, 10)
        );
        // SAF-20237: Get transformed roles (already flattened in app reducer)
        const availableRoles = (selectedEnterprise && selectedEnterprise.roles) || [];
        
        return {
            availableRoles: availableRoles,
            enterpriseId: enterpriseId,
            currentActiveRole: getCurrentActiveRole(state),
            userInfo: currentUserInfo(state)
        };
    },
    (dispatch, ownProps) => ({
        onRoleChange: (selectedRole) => {
            ownProps.handleRoleSwitch(selectedRole);
        }
    })
)(SwitchRoleMenu);

let EnterpriseDropdown = ({
    mappedEnterprise,
    getMappedEnterprises,
    isManagementUser,
    gridName,
    formName,
    userInfo,
    classes
}) => {
    const history = useHistory();
    return (
        
            <SelectContainer>
                <SelectField
                    name="enterpriseList"
                    isEnterprise
                    onChange={(e, value) =>
                        value 
                            ? getMappedEnterprises(
                                e,
                                value,
                                history,
                                isManagementUser,
                                gridName,
                                formName,
                                userInfo,
                                mappedEnterprise
                            )
                            : ''
                    }
                    options={mappedEnterprise &&  mappedEnterprise.length ? mappedEnterprise :[]}
                    renderOption={enterprise => {
                        return (
                            <MenuItem
                                key={enterprise.entId}
                                value={enterprise.entId}
                                className={classes.dropdownOptions}
                            >
                                {enterprise.entName}
                            </MenuItem>
                        )
                    }}
                />
            </SelectContainer>

        
    );
};


const UserMenuButton = connect(state => {
        const username = getUsername(state) || getPreferredUsername(state); //SAF-9074 Display preferred username as label for logout button if Fname and Lname not present
        const nameArray = username.split(' ') //['firstName', 'lastName']
        const firstName = nameArray[0]
        let initials = firstName.slice(0,1)?firstName.slice(0,1).toUpperCase():'';
        if(nameArray.length>1){
            const lastName = nameArray.pop();
            initials = initials.concat(lastName.slice(0,1).toUpperCase());
        }
        return ({
            label: initials 
        });
}

)(HeaderButton);

const TrialNetworksLink = styled.a`
    text-decoration: none;
`;
const ApplicationName = ()=>{
    return (<div className={styles.applicationName}>Safety Notifications</div>)
}
function SparkHeader({
    getMappedEnterprises,
    handleRoleSwitch,
    mappedEnterprise,
    isManagementUser,
    isGapPacketAdmin,
    isIBManagementUser,
    isRecipient,
    gridName,
    userInfo,
    classes,
    isSupportUser,
    enterpriseId,
    availableRoles,
    reportEnabled,
    resetReportType
}) {
    const history = useHistory();
    //SAF-18432-Safety - User Guide Integration- To hide navigation links when user is on User Guide page.
    const isUserGuidePage = history.location.pathname.includes('/userGuides');

    return (
            <HeaderBar>
                <ApplicationName />
                {!isUserGuidePage && (
                <React.Fragment>
                <Permission requires="sm.safetyManagementModule">
                    <Link to={enterpriseId ? paths.notifications: resourceNotFound()}>
                        <MenuButton label="Safety Home"  />
                    </Link>
                </Permission>
                <Permission requires="gp.manageGapPacket">
                    <Link to={enterpriseId ? gapPacketPaths.gapPacketList : resourceNotFound()}>
                        <MenuButton label="Gap Packet"  />
                    </Link>
                </Permission>
                {/* SAF-17154 Permission check for IBAdmin before allowing access to list view for IB */}
                <Permission requires="ib.manageIB"> 
                    <Link to={enterpriseId ? ibAdminPaths.notifications : resourceNotFound()}>
                        <MenuButton label="IB"  />
                    </Link>
                </Permission>
                {/* SAF-20237: Role Assignment - Switch Roles and its Precedence - PSR-4763 */}
                {/* Separate reporting links for each module (Safety, GP, IB) for management users */}
                <Permission requires="sm.safetyManagementModule">
                {enterpriseId && <Link to={paths.details.safetyReport}>
                    <MenuButton label="Safety Reporting" onClick={resetReportType} /> 
                        </Link>}
                </Permission>
                {/* SAF-18740 - resetting the reporttype so that the selected report type is cleared when switching between reporting tabs*/}
                {/* 18740 - Added reporting for Gap Packet */}
                <Permission requires="gp.manageGapPacket">
                    {enterpriseId && <Link to={gapPacketPaths.details.gapPacketReport}>
                        <MenuButton label="Gap Packet Reporting" onClick={resetReportType} />
                    </Link>}
                </Permission>
                <Permission requires="ib.manageIB">
                {enterpriseId && <Link to={ibAdminPaths.details.ibReport}>
                    <MenuButton label="IB Reporting" onClick={resetReportType} />
                        </Link>}
                </Permission>

                {/* SAF-20237: Recipient roles - Safety Reporting shown only if reportEnabled flag is true */}
                {/* reportEnabled flag is true if either reportEnabledSponsor or reportEnabledForCRO flag is true */}
                <Permission safetyRecipientOnly>
                    <Link to={enterpriseId ? notificationPaths.notifications: resourceNotFound()}>
                        <MenuButton label="Safety Home"  />
                    </Link> 
                    {reportEnabled && (
                        <Link to={notificationPaths.safetyReport}>
                            <MenuButton label="Safety Reporting" />
                        </Link> 
                    )}
                </Permission>
                
                <Permission gpRecipientOnly>
                    <Link to={enterpriseId ? gapPacketPaths.acknowledge : resourceNotFound()}>
                        <MenuButton label="Gap Packet"  />
                    </Link>
                </Permission>
                
                <Permission ibRecipientOnly>
                    {/* SAF-17154 Permission check for recipient before allowing access to recipient for IB */}
                    <Link to={enterpriseId ? ibRecipientPaths.notifications : resourceNotFound()}>
                        <MenuButton label="IB"  />
                    </Link>
                </Permission>

                <TrialNetworksLink
                    style={{ textDecoration: 'none' }}
                    href={trialNetworksTabLinkURL}
                    target="_blank"
                    rel="noopener noreferrer" 
                >
                    <MenuButton label="Site Portal"/>
                </TrialNetworksLink> {/* SAF-18222- Vulnerability Scan Issue fixes - reverse tab nabbing */}
                <div className={styles.flex}>
                <Permission requires="em.enterpriseModule">
                  <AdminMenu />
                </Permission>
                </div>
                
                
                    {availableRoles && availableRoles.length > 1 && (
                        <SwitchRoleMenu 
                            handleRoleSwitch={(selectedRole) => 
                                handleRoleSwitch(selectedRole, userInfo, enterpriseId, history, availableRoles)
                            }
                        />
                    )}
                <Typography >
                    {(mappedEnterprise && (isManagementUser || isRecipient || isSupportUser || isGapPacketAdmin || isIBManagementUser)) && ( 
                            <EnterpriseDropdown
                                getMappedEnterprises={getMappedEnterprises}
                                mappedEnterprise={mappedEnterprise}
                                isManagementUser={isManagementUser}
                                gridName={gridName}
                                userInfo={userInfo}
                                classes={classes}
                            />
                    )}
                </Typography>
                </React.Fragment>
                )}
                
                {isUserGuidePage && <div style={{ flex: 1 }} />}
                <UserMenu />
            </HeaderBar>
        );
}

// SAF-20237: Role Assignment - Switch Roles and its Precedence - PSR-4763
// Changed the order of the functions to ensure that the grid is loaded correctly after switching roles
// First unregister all grids, then set the new enterprise and refresh the grids
const adminRoute = (dispatch, history, formName, entId) => {
    dispatch(trackUser(entId)); // passing entId parameter to trackuser API as pat of 6.4 release
    dispatch(setSafetyNotifications());
    history.push('/safetyAdmin/notifications');
    dispatch(setCurrentEnterprise(entId));
    dispatch(refreshManagement('safetyAdminGrid', ()=> reset('safetyAdminGrid_advancedSearch')));
    dispatch(getEnterpriseCtmsRefreshDate(entId)).then(response =>
        dispatch(setCtmsRefreshDate(response)));
};

const gapPacketRoute = (dispatch, history,  entId) => {
    dispatch(trackUser(entId)); // passing entId parameter to trackuser API as pat of 6.4 release
    history.push('/gapPacketManagement/gapPacketList');
    dispatch(setCurrentEnterprise(entId));
    dispatch(refreshManagement('GapPacketResultsGrid', ()=> reset('gapPacketForm')));
    dispatch(getEnterpriseCtmsRefreshDate(entId)).then(response =>
        dispatch(setCtmsRefreshDate(response)));
};

const iBRoute = (dispatch, history,  entId) => { //SAF-17154 IBList view and CTMS Refresh date
    dispatch(trackUser(entId)); // passing entId parameter to trackuser API as pat of 6.4 release
    dispatch(setSafetyNotifications());
    history.push('/ibAdmin/notifications');
    dispatch(setCurrentEnterprise(entId));
    dispatch(refreshManagement('IBAdminGrid', ()=> reset('IBAdminGrid_advancedSearch')));
    dispatch(getEnterpriseCtmsRefreshDate(entId)).then(response =>
        dispatch(setCtmsRefreshDate(response)));
};

const safetyRecipientRoute = (dispatch, history, formName, entId) => {
    dispatch(setSafetyNotifications());
    history.push('/safetyNotifications/notifications');
    dispatch(setCurrentEnterprise(entId));
    resetFilters(dispatch, 'safetyletterRecipient', formName);
};

const gapPacketRecipientRoute = (dispatch, history, entId) => {
    history.push('/gapPacketManagement/acknowledge');
    dispatch(setCurrentEnterprise(entId));
    dispatch(refreshRecipient('GapPacketRecipientResultsGrid', ()=> reset('gapPacketForm')));
};

const ibRecipientRoute = (dispatch, history, entId) => {
    history.push('/ibNotifications/notifications');
    dispatch(setCurrentEnterprise(entId));
    dispatch(refreshRecipient('ibRecipient', ()=> reset('IBRecipientGridForm')));
};

const resetFilters = (dispatch, gridName, formName) => {
    dispatch(refreshRecipient(gridName, formName => change(formName, 'status', '')));
    dispatch(refreshRecipient(gridName, formName => change(formName, 'distDue', '')));
    dispatch(refreshRecipient(gridName, formName => change(formName, 'searchParam', '')));
    dispatch(refreshRecipient(gridName, formName => change(formName, 'sentDue', '')));
};

// SAF-20237: Set user role for selected enterprise based on role priority
const setRolesForEnterprise = (mappedEnterprise, entId, dispatch, userInfo, managementRoles) => {
    let selectedEnterpriseData =
        mappedEnterprise && mappedEnterprise.filter(value => value.entId === entId);
    dispatch(setDomainValue(selectedEnterpriseData[0].domain, userInfo, selectedEnterpriseData[0].isEntAutoEnabled));
    // SAF-20237: Access roles directly (already transformed in app reducer)
    let roles = selectedEnterpriseData[0].roles;
    let rolesList = roles && roles.map(role => role.roleVal);
    
    // API sends roles in priority order (Safety -> GP -> IB)
    // Simply take the first role from the list
    let selectedEntRole = (rolesList && rolesList.length > 0) ? rolesList[0] : '';
    
    return selectedEntRole;
};

// SAF-20237: Role Assignment - Switch Roles and its Precedence - PSR-4763
// SAF-20491: Navigate to appropriate module based on selected role (includes split support roles)
const executeNavigation = (dispatch, history, selectedRole, enterpriseId, userInfo, formName, allRoles) => {
    let managementRoles = [Roles.SAFETY_ADMIN, Roles.SAFETY_MANAGER, Roles.SAFETY_MONITOR, Roles.COUNTRY_LEAD, Roles.SAFETY_SUPPORT, Roles.GAP_PACKET_ADMIN, Roles.IB_ADMIN, Roles.IB_COUNTRY_LEAD, Roles.IB_MONITOR, Roles.IB_SUPPORT, Roles.GAP_PACKET_SUPPORT];
    let gapPacketRoles = [Roles.GAP_PACKET_ADMIN, Roles.GAP_PACKET_SUPPORT];
    let gapPacketRecipientRoles = [Roles.GP_RECP];
    let iBRoles = [Roles.IB_ADMIN, Roles.IB_COUNTRY_LEAD, Roles.IB_MONITOR, Roles.IB_SUPPORT];
    let ibRecipientRoles = [Roles.IB_RECP];
    
    dispatch(setUserInfo(userInfo, selectedRole));
    
    // SAF-20237: Extract and store reportEnabledForSponsor flag for the selected role
    // This flag is used to control report menu visibility for recipient roles
    const selectedRoleData = allRoles && allRoles.find(r => r.roleVal === selectedRole);
    const reportEnabledSponsor = selectedRoleData && selectedRoleData.reportEnabledForSponsor ? true : false;
    const reportEnabledCRO = selectedRoleData && selectedRoleData.reportEnabledForCRO ? true : false;
    
    dispatch(setReportEnabledForSponsor(reportEnabledSponsor));
    dispatch(setReportEnabledForCRO(reportEnabledCRO));
    dispatch(setCurrentEnterpriseRole(managementRoles.includes(selectedRole) ? 'MNGT' : 'RECP'));
    
    // Check module - now includes recipient roles
    let isIBRole = iBRoles.includes(selectedRole);
    let isGapPacketRole = gapPacketRoles.includes(selectedRole);
    let isGapPacketRecipientRole = gapPacketRecipientRoles.includes(selectedRole);
    let isIBRecipientRole = ibRecipientRoles.includes(selectedRole);
    
    // Navigate based on module, then management vs recipient
    if (isIBRole) {
        iBRoute(dispatch, history, enterpriseId);
    } else if (isIBRecipientRole) {
        ibRecipientRoute(dispatch, history, enterpriseId);
    } else if (isGapPacketRole) {
        gapPacketRoute(dispatch, history, enterpriseId);
    } else if (isGapPacketRecipientRole) {
        gapPacketRecipientRoute(dispatch, history, enterpriseId);
    } else if (managementRoles.includes(selectedRole)) {
        adminRoute(dispatch, history, formName, enterpriseId);
    } else {
        safetyRecipientRoute(dispatch, history, formName, enterpriseId);}
};

export default compose(
    connect(
        state => {
            const enterpriseId = userCurrentEnterprise(state);
            const mappedEnterprise = getMappedEnterpriseData(state);
            const selectedEnterprise = mappedEnterprise && mappedEnterprise.find(
                (ent) => ent.entId === parseInt(enterpriseId, 10)
            );
            // SAF-20237: Extract roles from transformed enterprise data (flat array with category)
            const availableRoles = (selectedEnterprise && selectedEnterprise.roles) || [];
            
            return {
                mappedEnterprise: mappedEnterprise,
                isManagementUser: isManagementUser(state),
                isRecipient: isRecipient(state),
                isGapPacketAdmin: isGapPacketAdmin(state),
                isIBManagementUser: isIBManagementUser(state), //SAF-1754 updating state
                userInfo: currentUserInfo(state),
                isSupportUser : isSupportUser(state),
                initialValues: {
                    enterpriseList: Number(enterpriseId)
                },
                enterpriseId: enterpriseId,
                reportingFlag: setReportingFlag(state),
                availableRoles: availableRoles,
                // SAF-20237: Get report access flag to control recipient reporting menu visibility
                // Report enabled if either sponsor or CRO flag is true
                reportEnabled: getReportEnabledForSponsor(state) || getReportEnabledForCRO(state)
            };
        },
        (dispatch, getState) => ({
            getMappedEnterprises: async (
                e,
                entId,
                history,
                isManagementUser,
                gridName,
                formName,
                userInfo,
                mappedEnterprise
            ) => {
                // SAF-19117 - Added IB Monitor role to the management roles list
                // SAF-20491: Added IB_SUPPORT and GAP_PACKET_SUPPORT (split from single Safety Support role)
                let managementRoles = [Roles.SAFETY_ADMIN, Roles.SAFETY_MANAGER, Roles.SAFETY_MONITOR, Roles.COUNTRY_LEAD, Roles.SAFETY_SUPPORT, Roles.GAP_PACKET_ADMIN, Roles.IB_ADMIN, Roles.IB_COUNTRY_LEAD, Roles.IB_MONITOR, Roles.IB_SUPPORT, Roles.GAP_PACKET_SUPPORT];
                let selectedEnterpriseData = mappedEnterprise && mappedEnterprise.filter(value => value.entId === entId);
                // SAF-20237: Extract available roles to pass to navigation for report flag lookup
                let availableRoles = selectedEnterpriseData[0].roles || [];
                let selectedEntRole = setRolesForEnterprise(
                    mappedEnterprise,
                    entId,
                    dispatch,
                    userInfo,
                    managementRoles
                );
                //dispatch(setDomainValue(domain, userInfo));
                executeNavigation(dispatch, history, selectedEntRole, entId, userInfo, formName, availableRoles);
            },
            // SAF-20237: Handle role switching with report flag update
            // Pass availableRoles to extract reportEnabledForSponsor for the new role
            handleRoleSwitch: (selectedRole, userInfo, enterpriseId, history, availableRoles) => {
                executeNavigation(dispatch, history, selectedRole, enterpriseId, userInfo, FORM_NAME, availableRoles);
            },
            resetReportType: () => dispatch(change('safetyReportForm', 'reportType', ''))
        })
    ),
    reduxForm({
        form: FORM_NAME
    }),
    withStyles(popupContentStyles)
)(SparkHeader);


